import 'babel-polyfill'
import React from 'react'
import ReactDOM from 'react-dom'
import { ConnectedRouter } from 'react-router-redux'
import { Route } from 'react-router-dom'
import { Provider } from 'react-redux'

import App from './app'
import store from './redux/store'
import history from './redux/history'

import './styles/vendor/bootstrap.min.css'
import 'react-datepicker/dist/react-datepicker.css'
import './styles/app.css'
import './styles/home.css'
import './styles/vendor/d3-tip.css'
import './styles/app.scss'

// NOTE: usisng pre-built css for react-selectize to avoid
// https://github.com/furqanZafar/react-selectize/issues/121
// Author hasn't released an updated package in 6 months, master branch has fix
import './styles/react-selectize.min.css'

import fontAwesome from 'font-awesome-webpack' // eslint-disable-line

ReactDOM.render(
    <Provider store={store}>
        <ConnectedRouter history={history}>
            <div>
                <Route path="/" component={App} />
            </div>
        </ConnectedRouter>
    </Provider>,
    document.getElementById('root')
)



// WEBPACK FOOTER //
// ./src/index.js